import supabaseClient from '@/api/supabaseClient.ts';
import { useQuery } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type Conversation = {
  user_id: string;
  user_name: string;
  user_photo?: string;
  last_message: string;
  last_message_time: string;
  is_last_message_mine: boolean;
  unread_count: number;
};

const useConversations = () => {
  const queryFn = async (): Promise<Conversation[]> => {
    const { data, error } = await supabaseClient.functions.invoke('get_conversations', {
      method: 'POST',
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data?.data?.conversations || [];
  };

  return useQuery<Conversation[], Error>({
    queryKey: ['conversations'],
    queryFn,
    refetchInterval: 5000, // Refetch every 5 seconds
  });
};

export default useConversations;
